// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2tb6Q","container":"styles_container__1RJot","title":"styles_title__1BtBU","wrapper":"styles_wrapper__18KlT","answer":"styles_answer__3-rmT"};